import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'element-plus/dist/index.css'
import '@/style/style.scss'
import '@/assets/font/iconfont.css' // global css
import ElementPlus from 'element-plus'
// if(process.env.VUE_APP_BASE_API==="http://127.0.0.1:8080/mock"){
//     require ('./mocks/index');
// }
createApp(App).use(ElementPlus).use(store).use(router).mount('#app')
